module.exports = __webpack_public_path__ + "static/media/5.e3f95d08.jpg";